"use client";
import type { FolderBlockDoc as FolderBlockTypes } from "../../types/blocks";
import React from "react";
import { CustomCard } from "../components/FolderCard";
import { Button } from "../components/ui/Button";

const initialCataloguesList = 3;
const incrementCataloguesList = 3;

const FolderBlock: React.FC<FolderBlockTypes> = (props) => {
  const { cards } = props;
  const [cataloguesListLength, setCataloguesListLength] = React.useState(
    initialCataloguesList
  );

  const loadMore = () => {
    setCataloguesListLength(cataloguesListLength + incrementCataloguesList);
  };

  return (
    <div className="flex flex-col gap-5 justify-center">
      <h3 className="text-4xl font-thin text-center">Nos catalogues</h3>
      <div className="flex flex-wrap gap-3 w-full justify-center p-10">
        {cards?.slice(0, cataloguesListLength).map((card) => (
          <CustomCard
            key={card.id}
            {...card.card}
            link={{ ...card.card.link, newTab: card.card.link.newTab ?? false }}
          />
        ))}
      </div>
      {cards && cataloguesListLength < cards?.length ? (
        <Button
          size="default"
          variant="default"
          className="mx-auto bg-stone-600 hover:bg-stone-700"
          onClick={loadMore}
        >
          Voir tous les catalogues
        </Button>
      ) : null}
    </div>
  );
};

export { FolderBlock };
